import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private enableSidebar = new BehaviorSubject<boolean>(true);
  private mobileSidebarOpen = new BehaviorSubject<boolean>(false);

  currentEnableSidebar = this.enableSidebar.asObservable();
  mobileSidebarOpen$ = this.mobileSidebarOpen.asObservable();

  constructor() { }

  setEnableSidebar(enableSidebar: boolean) {
    this.enableSidebar.next(enableSidebar);
  }

  getEnableSidebar() {
      return this.enableSidebar;
  }

  setMobileSidebarOpen(open: boolean) {
    this.mobileSidebarOpen.next(open);
  }

  toggleMobileSidebar() {
    this.mobileSidebarOpen.next(!this.mobileSidebarOpen.value);
  }

  closeMobileSidebar() {
    this.setMobileSidebarOpen(false);
  }
}
